<template>
  <div id="app">
    <Navigation/>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import '@/sass/bulma.scss';

import Navigation from '@/components/Navigation.vue';
import Footer from '@/components/Footer.vue';

export default {
  components: {
    Navigation,
    Footer,
  },
};
</script>

<style lang="scss">
body {
  overflow-x: hidden;
  overflow-y: scroll;
}

.icon {
  span {
    width: 100%;
    height: 100%;
    svg {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

